import React, { useState } from "react";

export default function NewsletterNews() {
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      alert(`Subscribed successfully with email: ${email}`);
      setEmail("");
    }
  };

  return (
    <section className="w-full py-12 px-6 bg-black/60 backdrop-blur-sm border-y border-neutral-900 text-white">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-8">
        {/* Left Side: Heading */}
        <div className="w-full md:w-1/2 text-left">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold font-oswald text-secondary tracking-widest uppercase mb-2">
            Subscribe
          </h2>
          <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold font-oswald text-white tracking-widest uppercase">
            Newsletter
          </h3>
        </div>

        {/* Right Side: Input & Action */}
        <div className="w-full md:w-1/2 flex justify-end">
          <form onSubmit={handleSubmit} className="w-full max-w-md flex items-center relative">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your Email Address"
              required
              className="w-full bg-neutral-950 border border-neutral-800 focus:border-secondary px-5 py-4 rounded-lg text-white placeholder-neutral-500 font-outfit text-sm focus:outline-none transition-all pr-16"
            />
            <button
              type="submit"
              className="absolute right-1.5 top-1.5 bottom-1.5 aspect-square bg-secondary hover:bg-white text-black font-bold flex items-center justify-center rounded-md transition-all duration-300 active:scale-95 outline-none focus:outline-none"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
              </svg>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
